var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFireSketch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 217.942,
    x2: 328.936,
    y1: 293.329,
    y2: 375.825
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9356",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff755c"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff755c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff4181"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 63.047,
    x2: 284.354,
    xlinkHref: "#lg1",
    y1: 126.487,
    y2: 390.319
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 313.352,
    x2: 346.612,
    xlinkHref: "#lg1",
    y1: 108.331,
    y2: 108.331
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 209.177,
    x2: 35.186,
    y1: 326.095,
    y2: 90.607
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff755c",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffce47"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 154.892,
    x2: 222.892,
    y1: 265.396,
    y2: 425.396
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#843561",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3a2f4d"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 26.467,
    x2: 49.709,
    xlinkHref: "#lg1",
    y1: 180.851,
    y2: 180.851
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 286.488,
    x2: 312.116,
    xlinkHref: "#lg1",
    y1: 95.517,
    y2: 95.517
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientTransform: "matrix(.707 .707 -.707 .707 1545.855 -893.195)",
    gradientUnits: "userSpaceOnUse",
    x1: -121.009,
    x2: 2.181,
    y1: 1814.914,
    y2: 1814.914
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe0ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffc0d5"
  }))), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffce47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9356"
  }))), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 207.644,
    x2: 510,
    xlinkHref: "#lg2",
    y1: 209.815,
    y2: 209.815
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 392.002,
    x2: 304.067,
    xlinkHref: "#lg2",
    y1: 248.921,
    y2: 160.986
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientTransform: "matrix(.707 .707 -.707 .707 1545.855 -893.195)",
    gradientUnits: "userSpaceOnUse",
    x1: -63.133,
    x2: -31.7,
    y1: 1875.775,
    y2: 1875.775
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2f73a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#174461"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m305.94 121.179c-.341-2.962-5.447-3.88-7.552-1.372-3.228 3.846-7.272 9.025-11.635 15.468-2.132 3.148-7.99 3.284-10.362.236-26.597-34.175-58.441-80.851-92.669-80.851-54.532 0-103.019 83.96-133.861 149.164-4.182 8.841-20.864 8.791-24.702-.14-.058-.136-.116-.272-.174-.409-1.637-3.911-9.063-3.721-10.47.241-12.747 35.894-34.638 124.116 26.228 191.777 29.839 36.057 82.701 60.047 142.98 60.047 48.034 0 91.346-15.247 122.072-39.677 13.879-12.682 63.56-48.286 63.56-125.67-.001-99.919-58.6-126.95-63.415-168.814z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m298.388 119.807c-3.228 3.846-7.272 9.025-11.635 15.468-2.132 3.148-7.99 3.284-10.362.236-26.597-34.175-58.441-80.851-92.669-80.851-54.532 0-103.02 83.96-133.861 149.164-4.182 8.841-20.864 8.791-24.702-.14-.058-.136-.116-.272-.173-.409-1.637-3.911-9.063-3.721-10.47.241-12.748 35.894-34.639 124.116 26.227 191.777 29.839 36.057 82.701 60.047 142.98 60.047 48.034 0 91.346-15.247 122.072-39.677 13.879-12.682 63.56-48.286 63.56-125.67 0-99.919-58.599-126.951-63.414-168.814-.341-2.961-5.447-3.88-7.553-1.372z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m340.344 90.403c-.034-.397-.538-.52-.747-.184-.319.515-.719 1.209-1.15 2.072-.211.422-.79.44-1.024.032-2.629-4.578-5.777-10.831-9.16-10.831-5.391 0-10.681 10.96-13.232 19.983-6.43 22.744 7.274 33.695 13.232 33.695 4.748 0 9.03-2.043 12.067-5.316 1.372-1.699 6.283-6.469 6.283-16.836-.001-13.385-5.794-17.006-6.269-22.615z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m184.794 130.799c-59.626 0-107.962 134.196-107.962 186.978s48.336 95.571 107.962 95.571 107.962-42.788 107.962-95.571-48.336-186.978-107.962-186.978z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m263.213 343.928c0 38.339-35.109 69.419-78.419 69.419s-78.419-31.08-78.419-69.419 35.109-135.813 78.419-135.813 78.419 97.475 78.419 135.813z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.088 160.54c-6.418 0-11.621 19.293-11.621 26.882s5.203 13.74 11.621 13.74 11.621-6.152 11.621-13.74-5.203-26.882-11.621-26.882z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 299.302,
    cy: 95.517,
    fill: "url(#SVGID_7_)",
    r: 12.814
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m207.644 273.886-33.921 94.889-1.512 27.465c-2.091 5.851 27.651-1.325 27.651-1.325l94.889-33.921c24.126-24.126-62.982-111.234-87.107-87.108z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m505.076 150.682-210.328 210.311c-2.385-4.133-6.009-7.79-10.652-10.381-6.343-3.513-16.263-1.59-23.131.493-1.494.445-2.862-.334-3.418-1.526-.35-.715-.413-1.59-.032-2.448.016 0 .016-.016.016-.016.382-.874.716-1.765 1.002-2.655.127-.429.254-.858.382-1.288.016-.032.016-.048.016-.079.366-1.383.62-2.766.763-4.181.048-.461.08-.938.111-1.399.04-.768.047-1.536.022-2.304-.174-5.375-1.93-10.712-5.268-15.247-.811-1.113-1.717-2.162-2.718-3.164-1.002-1.002-2.051-1.908-3.164-2.719-5.183-3.816-11.415-5.564-17.551-5.246-.461.032-.938.064-1.399.111-1.415.143-2.814.397-4.181.763-.032 0-.048 0-.08.016-.429.127-.859.254-1.288.382-.461.143-.906.302-1.351.477-.429.159-.859.334-1.288.525-.016 0-.016 0-.032.016-.859.382-1.733.318-2.448-.032-1.192-.556-1.971-1.924-1.526-3.418 2.083-6.868 4.006-16.772.493-23.115-2.592-4.658-6.232-8.283-10.381-10.667l210.311-210.329c6.582-6.566 17.233-6.566 23.799 0l12.416 12.416 38.488 38.489 12.416 12.416c6.566 6.565 6.566 17.217.001 23.799z",
    fill: "url(#SVGID_9_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m492.66 114.466-235.113 235.113c-.35-.715-.413-1.59-.032-2.448.016 0 .016-.016.016-.016.382-.874 2.035-6.804 2.162-8.203.064-.477.095-.938.111-1.399.318-6.137-1.431-12.368-5.246-17.551-.811-1.113-1.717-2.162-2.718-3.164-1.002-1.002-2.051-1.908-3.164-2.719-5.183-3.816-11.415-5.564-17.551-5.246-.461.016-.922.048-1.399.111-1.399.127-2.798.382-4.181.763-.032 0-.048 0-.08.016-.429.111-3.497 1.192-3.927 1.383-.016 0-.016 0-.032.016-.859.382-1.733.318-2.448-.032l235.113-235.112z",
    fill: "url(#SVGID_10_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m188.824 379.813c-4.576-4.576-9.691-8.248-15.102-11.038l-9.308 26.038c-2.092 5.851 3.559 11.501 9.41 9.41l26.038-9.308c-2.789-5.412-6.461-10.526-11.038-15.102z",
    fill: "url(#SVGID_11_)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFireSketch);
export default __webpack_public_path__ + "static/media/icon-fire-sketch.416065c8f16ff6e5a6dd1a65d8bca14d.svg";
export { ForwardRef as ReactComponent };